// extracted by mini-css-extract-plugin
module.exports = {"container":"question-wrapper_container__1QWJZ"};